"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4145],{

/***/ 54145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30693);



var farms = [
    /**
   * These 3 farms (PID 0, 2, 3) should always be at the top of the file.
   */ {
        pid: 0,
        lpSymbol: "PiB",
        lpAddress: "0x45b19b46Be1B9006F388873E2C460FCcc7d00F15",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTokens.busd */ .ds.busd,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTokens.pib */ .ds.pib
    },
    {
        pid: 1,
        lpSymbol: "BUSD-PiB LP",
        lpAddress: "0x78d418652d57300044bB34DC855335438497BABf",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTokens.pib */ .ds.pib,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTokens.busd */ .ds.busd,
        boosted: false
    },
    {
        pid: 2,
        lpSymbol: "WPi-BUSD LP",
        lpAddress: "0xf6213F3fFA22D9a6C08b024E93409a9Dd936C0F5",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTokens.wpi */ .ds.wpi,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTokens.busd */ .ds.busd,
        boosted: false
    }, 
].map(function(p) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, p), {
        token: p.token.serialize,
        quoteToken: p.quoteToken.serialize
    });
});
/* harmony default export */ __webpack_exports__["default"] = (farms);


/***/ })

}]);